import { login, loginWithStoreId, refreshToken } from '@/api/user';
import { showProfile, updateProfile } from '@/utils/auth';
import { encodeRedirect } from '@/utils/redirect';
import RouteConfig from "@/router/config";
import router from '@/router';

const mutations = {
  SET_PROFILE(state, user) {
    state.id = user.id || 0;
    state.store_id = user.store_id || 0;
    state.role = user.role || '';
    state.expiry_time = user.expiry_time || 0;
    state.token = user.token || '';
    state.nickname = user.nickname || '';
    state.avatar = user.avatar || '';
    state.is_generic = user.is_generic || 0;
    state.isAdministrator = user.role === 'administrator';
    state.isManager = user.role === 'manager';
    state.isReceptionist = ['receptionist', 'receptionist_shift', 'consultant'].includes(user.role);
    state.isGenericStore = user.role === 'administrator' ? 1 : user.is_generic;
    state.isHeadOffice = user.is_head_office || 0;
    updateProfile(user);
    return state;
  },
  SET_STORE_ID: (state, storeId) => {
    state.store_id = storeId;
  },
  SET_TOKEN: (state, user) => {
    state.token = user.token;
    state.expiry_time = user.expiry_time;
    updateProfile(user);
    return state;
  },
};

const actions = {
  async login({ commit }, { username = '', password = '', we_chat_code = '' }) {
    const { isError, data } = await login({ username: username.trim(), password, we_chat_code });
    if (isError) return { isError };
    if (data.stores.length > 0) return { isError, stores: data.stores };

    commit('SET_PROFILE', data);
    return { isError };
  },

  async loginWithStoreId({ commit }, userInfo) {
    commit('SET_STORE_ID', userInfo.store_id);

    const { username, password, we_chat_code } = userInfo;

    const { isError, data } = await loginWithStoreId({ username: username.trim(), password, we_chat_code });

    if (isError) return { isError };

    commit('SET_PROFILE', data);
    return { isError };
  },

  async refreshToken({ commit }) {
    const { isError, data } = await refreshToken();
    if (isError) return { isError };
    if (!data.token) return { isError, data };

    const user = showProfile();
    user.token = data.token;
    user.expiry_time = data.expire_time;
    commit('SET_TOKEN', user);
    return { isError, data };
  },

  logout({ commit }, payload) {
    commit('SET_PROFILE', {});
    const currentRoute = router.currentRoute;
    const redirect = {
      path: currentRoute.path,
      query: currentRoute.query
    };
    let query = {};
    if (payload && payload.is_not_auto_login) query.is_not_auto_login = 1;
    if (redirect && redirect.path) query.redirect = encodeRedirect(redirect.path, redirect.query);
    RouteConfig.login.push(query);
  },

  syncProfile({ commit }) {
    const user = showProfile();
    commit('SET_PROFILE', user);
    if (!user.id) {
      // 踢回登录页时同样带上当前页面作为回跳目标
      const { path, query } = router.currentRoute;
      RouteConfig.login.push({ is_not_auto_login: 1, redirect: encodeRedirect(path, query) });
    }
  },
};

const getInitialState = () => ({
  id: 0,
  store_id: 0,
  role: '',
  expiry_time: 0,
  token: '',
  nickname: '',
  avatar: '',
  is_generic: 0,
  isAdministrator: false,
  isManager: false,
  isReceptionist: false,
  isGenericStore: 0,
  isHeadOffice: 0
});

const state = getInitialState();

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
